<template>
  <div class="games-filter" :class="{ 'games-filter--active': isActive }" @click="openGamesFilterModal">
    <div class="games-filter__text">
      {{ getContent(gamesContent?.currentLocaleData, gamesContent?.defaultLocaleData, 'filter_title') }}
    </div>

    <div v-if="isActive" class="games-filter__circle" />

    <atomic-icon id="provider-filter" />
  </div>
</template>

<script setup lang="ts">
  import { ModalName } from '@skeleton/consts/modals';

  const props = withDefaults(
    defineProps<{
      isActive: boolean;
      hideProviders?: boolean;
    }>(),
    {
      isActive: false,
      hideProviders: false,
    }
  );

  const { openModal } = useModalStore();
  const { getContent } = useProjectMethods();
  const gamesContentStore = useGamesContentStore();
  const { content: gamesContent } = storeToRefs(gamesContentStore);

  const openGamesFilterModal = () => {
    openModal(ModalName.GAMES_FILTER, {
      props: { hideProviders: props.hideProviders },
    });
  };
</script>

<style src="~/assets/styles/components/filters/games-filter.scss" lang="scss" />
